export const retrieveEducationLevelSpecificOptions = <T extends { relatedEducationLevelIds?: string[] }>(options: T[], educationLevelId: string): T[] => options
    .filter(option => option.relatedEducationLevelIds?.includes(educationLevelId));
